<template>
  <v-text-field :readonly="readonly" v-model="model[`${prop.value}`]" :label="prop.text" :clearable="!readonly"
    :color="prop.color">

  </v-text-field>
</template>

<style scoped>

</style>

<script>
  import TextInput from "./textInput.ts";
  export default TextInput;
</script>